module.exports = __webpack_public_path__ + "static/media/Gardes.original.ac9bbf7d.jpg";